import { useEffect, useState } from "react";
import { getBranding } from "@/lib/apiClient";

let cache = null;

export function BrandLogo({ imgClass = "", fallback = null }) {
  const [b, setB] = useState(cache);
  useEffect(() => {
    const load = () => getBranding().then((d) => { cache = d; setB(d); }).catch(() => {});
    if (!cache) load();
    const h = () => load();
    window.addEventListener("branding-updated", h);
    return () => window.removeEventListener("branding-updated", h);
  }, []);
  if (b?.logo_data_url) return <img src={b.logo_data_url} alt={b.company_name || "Flex Estate"} className={imgClass} data-testid="brand-logo" />;
  return fallback;
}
